import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { ScreenText } from '@/lang/ScreenText'
import WidgetFormItem from '../WidgetFormItem/WidgetFormItem.vue'
import ElementLabelComponent from '../elementLabelComponent/ElementLabelComponent.vue'
import CustomFieldComponent from '../customFieldComponent/CustomFieldComponent.vue'
import CommonActionComponent from '../commonActionComponent/CommonActionComponent.vue'
import formsStore from '@/store/modules/forms/formsStore'
import APP_CONST from '@/constants/AppConst'

@Component({
  name: 'widget-form',
  components: {
    WidgetFormItem,
    'element-label': ElementLabelComponent,
    'custom-element': CustomFieldComponent,
    'common-action': CommonActionComponent
  }
})
export default class WidgetForm extends Vue {
  APP_CONST = APP_CONST
  private objScreenText: ScreenText = new ScreenText()
  private addIntroduction: boolean = false
  private formJSON: any = { intro: '', form_footer: '', form_name: 'Type Form Name' }
  private addFormFooter: boolean = false
  private data: any = []
  private syncDone: boolean = false

  @Prop()
  select!: any

  @Prop()
  formIndex!: number

  @Prop()
  addNewElement!: any

  get applicationParts() {
    return formsStore.applicationsPartsData.forms
  }

  get formData() {
    return this.applicationParts[this.formIndex]
      ? this.applicationParts[this.formIndex].source
      : { list: [], config: {} }
  }

  public selectWidget: any = this.select
  public selectedIndex: number = -1
  public singleElementWatcher: boolean = false

  @Watch('select', { deep: true })
  watchselect(value: any) {
    this.selectWidget = value
  }

  @Watch('selectWidget', { deep: true })
  watchselectWidget(val: any) {
    this.$emit('update:select', val)
  }

  @Watch('formData', { deep: true })
  syncFormData(val: any) {
    this.data = val
    if (!this.syncDone) {
      this.syncDone = true
      this.defaultValuesInConfigDetails()
    }
  }

  @Watch('addNewElement', { deep: true })
  addNewElementinList(val: any) {
    /* istanbul ignore else */
    if (this.addNewElement) {
      const newIndex = { newIndex: this.formData.list.length - 1 }
      this.handleWidgetAdd(newIndex)
    }
  }

  mounted() {
    document.body.ondrop = function (event) {
      const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      if (isFirefox) {
        event.preventDefault()
        event.stopPropagation()
      }
    }

    this.data = this.formData
    this.resetSelectedValues()
    this.defaultValuesInConfigDetails()
  }

  resetSelectedValues() {
    this.formData.list.forEach((element: any) => {
      if (element.elmType === 'single') {
        element.options.defaultValue = ''
      } else if (element.elmType === 'grid') {
        element.columns.forEach((item: any) => {
          item.list.forEach((itm: any) => {
            itm.options.defaultValue = ''
          })
        })
      } else if (element.elmType === 'addressGrid') {
        element.columns.forEach((item: any) => {
          item.list.forEach((itm: any) => {
            itm.options.defaultValue = ''
            if (itm.elmType === 'grid') {
              itm.columns.forEach((elements: any) => {
                elements.list.forEach((items: any) => {
                  if (items.type === 'select') {
                    items.options.defaultValue = 'State'
                  } else {
                    items.options.defaultValue = ''
                  }
                })
              })
            }
          })
        })
      }
    })
  }

  updateHeaderCount() {
    let count = 0
    for (let i = 0; i < this.data.list.length; i++) {
      if (this.data.list[i].type == 'sectionHeader') {
        count++
        this.data.list[i].dropIndex = count
        this.data.list[i] = { ...this.data.list[i] }
      }
    }
  }

  setRequired(event: any) {
    const element: any = event.element
    const index: any = event.index
    /* istanbul ignore else */
    if (element.elmType === 'grid') {
      element.columns.forEach((item: any) => {
        item.list.forEach((itm: any) => {
          itm.options.required = itm.options.required == false ? true : false
        })
      })
    } else if (element.elmType === 'addressGrid') {
      element.columns.forEach((item: any) => {
        item.list.forEach((itm: any) => {
          itm.options.required = itm.options.required == false ? true : false
          if (itm.elmType === 'grid') {
            itm.columns.forEach((elements: any) => {
              elements.list.forEach((items: any) => {
                items.options.required = items.options.required == false ? true : false
              })
            })
          }
        })
      })
    } else if (element.elmType === 'single') {
      element.options.required = element.options.required == false ? true : false
    } else if (element.elmType === 'custom') {
      element.options.required = element.options.required == false ? true : false
    }
    this.data.list[index] = { ...element }
    // formBuilderStore.updateFormData(this.data);
  }

  handleMoveEnd(newIndex: number, oldIndex: number) {
    this.updateHeaderCount()
  }

  handleSelectWidget(index: number) {
    // this.selectedIndex = index
    // this.selectWidget = this.formData.list[index];
  }

  handleWidgetAdd(evt: any) {
    const newIndex = evt.newIndex
    const to = evt.to
    const date: any = new Date()
    const key = Date.parse(date) + '_' + Math.ceil(Math.random() * 99999)
    const modelKey = Date.parse(date) + '_' + Math.ceil(Math.random() * 55555)
    this.$set(this.data.list, newIndex, {
      ...this.data.list[newIndex],
      options: {
        ...this.data.list[newIndex].options,
        remoteFunc: 'func_' + key
      },
      key: key + '_' + this.data.list[newIndex].type,
      // 绑定键值
      model: this.data.list[newIndex].name + '_' + key
      // rules: []
    })

    if (
      this.data.list[newIndex].type === 'radio' ||
      this.data.list[newIndex].type === 'checkbox' ||
      this.data.list[newIndex].type === 'select' ||
      this.data.list[newIndex].elmType === 'custom'
    ) {
      if (
        this.data.list[newIndex].type == 'textAreaQuestion' ||
        this.data.list[newIndex].type == 'textAreaLongQuestion'
      ) {
        this.$set(this.data.list, newIndex, {
          ...this.data.list[newIndex],
          options: {
            ...this.data.list[newIndex].options
          }
        })
      } else {
        this.$set(this.data.list, newIndex, {
          ...this.data.list[newIndex],
          options: {
            ...this.data.list[newIndex].options,
            options: this.data.list[newIndex].options.options.map((item: any) => ({
              ...item
            }))
          }
        })
      }
    }
    if (this.data.list[newIndex].elmType === 'grid') {
      this.$set(this.data.list, newIndex, {
        ...this.data.list[newIndex],
        columns: this.data.list[newIndex].columns.map((item: any) =>
          JSON.parse(JSON.stringify(item))
        )
      })
    } else if (this.data.list[newIndex].elmType === 'addressGrid') {
      const cloned = JSON.parse(JSON.stringify(this.data.list[newIndex].columns))
      cloned.map((item: any) => {
        item.list.forEach((itm: any) => JSON.parse(JSON.stringify(itm)))
      })
      this.data.list[newIndex].columns = cloned
    }

    this.selectWidget = this.data.list[newIndex]
    // formBuilderStore.updateFormData(this.data);
  }

  handleWidgetColAdd($event: any, row: any, colIndex: number) {
    const newIndex = $event.newIndex
    const oldIndex = $event.oldIndex
    const item = $event.item

    // 防止布局元素的嵌套拖拽
    if (item.className.indexOf('data-grid') >= 0) {
      // 如果是列表中拖拽的元素需要还原到原来位置
      item.tagName === 'DIV' &&
        this.data.list.splice(oldIndex, 0, row.columns[colIndex].list[newIndex])

      row.columns[colIndex].list.splice(newIndex, 1)

      return false
    }

    const date: any = new Date()
    const key = Date.parse(date) + '_' + Math.ceil(Math.random() * 99999)

    this.$set(row.columns[colIndex].list, newIndex, {
      ...row.columns[colIndex].list[newIndex],
      options: {
        ...row.columns[colIndex].list[newIndex].options,
        remoteFunc: 'func_' + key
      },
      key,
      // 绑定键值
      model: row.columns[colIndex].list[newIndex].type + '_' + key,
      rules: []
    })

    if (
      row.columns[colIndex].list[newIndex].type === 'radio' ||
      row.columns[colIndex].list[newIndex].type === 'checkbox' ||
      row.columns[colIndex].list[newIndex].type === 'select'
    ) {
      this.$set(row.columns[colIndex].list, newIndex, {
        ...row.columns[colIndex].list[newIndex],
        options: {
          ...row.columns[colIndex].list[newIndex].options,
          options: row.columns[colIndex].list[newIndex].options.options.map((item: any) => ({
            ...item
          }))
        }
      })
    }
    // formBuilderStore.updateFormData(this.data);
    this.selectWidget = row.columns[colIndex].list[newIndex]
  }

  handleWidgetDelete(index: number) {
    // if (this.formData.list.length - 1 === index) {
    //   if (index === 0) {
    //     this.selectWidget = {}
    //   } else {
    //     this.selectWidget = this.formData.list[index - 1]
    //   }
    // } else {
    //   this.selectWidget = this.formData.list[index + 1]
    // }
    // this.$nextTick(() => {
    //   this.data.list.splice(index, 1);
    //   formBuilderStore.updateFormData(this.data);
    //   this.updateHeaderCount()
    // })
  }

  handleSingleWidgetDelete(index: number) {
    // if (this.formData.list.length - 1 === index) {
    //   if (index === 0) {
    //     this.selectWidget = {}
    //   } else {
    //     this.selectWidget = this.formData.list[index - 1]
    //   }
    // } else {
    //   this.selectWidget = this.formData.list[index + 1]
    // }
    // this.$nextTick(() => {
    //   this.data.list.splice(index, 1)
    //   formBuilderStore.updateFormData(this.data);
    //   this.updateHeaderCount()
    // })
  }

  handleSingleSelectWidget(element: any, index: number) {
    this.selectedIndex = index
    /* istanbul ignore else */
    if (element.isDrag) {
      // this.selectWidget = this.formData.list[index];
    }
  }

  defaultValuesInConfigDetails() {
    const formNameRef: any = this.$refs.form_name
    if (formNameRef && formNameRef.innerText != this.data.config.formName) {
      formNameRef.innerText = this.data.config.formName.length
        ? this.data.config.formName
        : 'Type Form Name'
    }

    if (
      (!this.formJSON.intro.length ||
        (!this.data.config.intro.length && this.formJSON.intro.length)) &&
      this.data.config.intro != this.formJSON.intro
    ) {
      this.formJSON.intro = this.data.config.intro
    }

    if (
      (!this.formJSON.form_footer.length ||
        (!this.data.config.formFooter.length && this.formJSON.form_footer.length)) &&
      this.data.config.formFooter != this.formJSON.form_footer
    ) {
      this.formJSON.form_footer = this.data.config.formFooter
    }
  }

  saveIntro() {
    this.addIntroduction = false
    const introRef: any = this.$refs.intro_box
    this.formJSON.intro = introRef.innerText.slice(0, 650)
    this.data.config.intro = this.formJSON.intro
    introRef.innerText = introRef.innerText.slice(0, 650)
    // formBuilderStore.updateFormData(this.data);
  }

  includeFooter() {
    this.addFormFooter = true
  }

  saveFooter() {
    this.addFormFooter = false
    const footerRef: any = this.$refs.footer_box
    this.formJSON.form_footer = footerRef.innerText.slice(0, 150)
    this.data.config.formFooter = this.formJSON.form_footer
    footerRef.innerText = footerRef.innerText.slice(0, 150)
    // formBuilderStore.updateFormData(this.data);
  }

  includeIntroduction() {
    this.addIntroduction = true
  }

  saveFormName() {
    const formNameRef: any = this.$refs.form_name
    const innerText = formNameRef.innerHTML.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '')
    formNameRef.innerHTML = ''
    formNameRef.innerHTML = innerText
    this.formJSON.form_name = formNameRef.innerText
    this.formJSON.form_name = this.formJSON.form_name.trim()
    formNameRef.innerHTML = this.formJSON.form_name
    this.data.config.formName = this.formJSON.form_name
    // formBuilderStore.updateFormData(this.data);
  }

  updateFormName() {
    const formNameRef: any = this.$refs.form_name
    this.formJSON.form_name = formNameRef.innerText
    this.data.config.formName = this.formJSON.form_name
    // formBuilderStore.updateFormData(this.data);
  }

  onlyLimitedCharactersAllowed($event: any, refValue: string, characterLimit: number) {
    const formElementRef: any = this.$refs[refValue]
    switch (refValue) {
      case 'footer_box':
        this.data.config.formFooter = formElementRef.innerText
        break
      case 'form_name':
        this.data.config.formName = formElementRef.innerText
        break
      case 'intro_box':
        this.data.config.intro = formElementRef.innerText
        break
    }
    // formBuilderStore.updateFormData(this.data);
    if (formElementRef.innerText.length >= characterLimit) {
      $event.preventDefault()
    }
  }

  convertToPlainText(e: any, refValue: any) {
    // Get the copied text from the clipboard
    const pastedData = e.clipboardData
      ? (e.originalEvent || e).clipboardData.getData('text/plain')
      : // For IE
        (<any>window).clipboardData
        ? (<any>window).clipboardData.getData('Text')
        : ''

    if (document.queryCommandSupported('insertText')) {
      document.execCommand('insertText', false, pastedData)
    } else {
      // Insert text at the current position of caret
      const range = (<any>document).getSelection().getRangeAt(0)
      range.deleteContents()
      const textNode = document.createTextNode(pastedData)
      range.insertNode(textNode)
      range.selectNodeContents(textNode)
      range.collapse(false)

      const selection = (<any>window).getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
    }
  }

  pasteValue(e: any, refValue: string, characterLimit: number) {
    const formElementRef: any = this.$refs[refValue]
    e.preventDefault()
    const pastedData: any = this.$refs[refValue]
    this.convertToPlainText(e, refValue)
    if (!formElementRef.innerText.length && pastedData.length > characterLimit) {
      e.stopPropagation()
      e.preventDefault()
      formElementRef.innerText = pastedData.slice(0, characterLimit)
    } else if (
      formElementRef.innerText.length &&
      formElementRef.innerText.length + pastedData.length > characterLimit
    ) {
      e.stopPropagation()
      e.preventDefault()
      formElementRef.innerText =
        formElementRef.innerText +
        pastedData.slice(0, characterLimit - formElementRef.innerText.length)
    }

    switch (refValue) {
      case 'footer_box':
        this.data.config.formFooter = formElementRef.innerText
        break
      case 'form_name':
        this.data.config.formName = formElementRef.innerText
        break
      case 'intro_box':
        this.data.config.intro = formElementRef.innerText
        break
    }
    // formBuilderStore.updateFormData(this.data);
  }

  addNewQuestion(element: any, index: number) {
    // let storeData = this.formData
    // let indexKey =storeData.list.findIndex((res:any) => res.key === element.key)
    // let id = element.options.options.length+1
    // element.options.options.push({value:`Option ${id}`,label:`Option ${id}`})
    // storeData.list[indexKey] = {...element};
    // formBuilderStore.updateFormData(storeData);
  }

  deleteDropdown($event: any, element: any, index: number) {
    $event.preventDefault()
    $event.stopPropagation()
    // element.options.options.push({value:`Option${id}`,label:`Option${id}`})
    // let storeData = this.formData
    // let indexKey =storeData.list.findIndex((res:any) => res.key === element.key)
    // element.options.options.splice(index,1)
    // storeData.list[indexKey] = {...element};
    // formBuilderStore.updateFormData(storeData);
  }

  editOptions($event: any, element: any, index: number) {
    let refValue = ''
    $event.preventDefault()
    switch (element.type) {
      case 'singleChoice':
        refValue = `singleChoice-${element.key}-${index}`
        break
      case 'multipleChoice':
        refValue = `multipleChoice-${element.key}-${index}`
        break
      case 'dropdown':
        refValue = `dropdown-${element.key}-${index}`
        break
    }
    const doc: any = document.getElementById(refValue)
    const innerText = $event.target.innerHTML.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '')
    doc.innerHTML = ''
    doc.innerHTML = innerText
    // let storeData = this.formData;
    // let indexKey =storeData.list.findIndex((res:any) => res.key === element.key)
    // storeData.list[indexKey].options.options[index].value = storeData.list[indexKey].options.options[index].label = innerText;
  }

  editLabel(event: any, element: any, index: number) {
    let refValue = ''
    event.preventDefault()
    switch (element.type) {
      case 'singleChoice':
        refValue = `singleChoice-${element.key}-${index}`
        break
      case 'multipleChoice':
        refValue = `multipleChoice-${element.key}-${index}`
        break
      case 'dropdown':
        refValue = `dropdown-${element.key}-${index}`
        break
    }

    const pastedData = this.$refs[refValue]
    this.convertToPlainText(event, refValue)
    // let storeData = this.formData;
    // let indexKey =storeData.list.findIndex((res:any) => res.key === element.key)
    // storeData.list[indexKey].options.options[index].value = storeData.list[indexKey].options.options[index].label = pastedData;
  }

  pasteLabel(event: any, element: any) {
    let refValue = ''
    event.preventDefault()
    refValue = `label-${element.key}`
    const pastedData = this.$refs[refValue]
    this.convertToPlainText(event, refValue)
    // let storeData = this.formData
    // let indexKey =storeData.list.findIndex((res:any) => res.key === event.element.key)
    // element.label = pastedData;
    // storeData.list[indexKey] = {...element};
    // formBuilderStore.updateFormData(storeData);
  }

  updateLabel(event: any) {
    // let storeData = this.formData
    // let indexKey =storeData.list.findIndex((res:any) => res.key === event.element.key)
    // let newelement = event.element;
    // newelement.label = event.doc;
    // storeData.list[indexKey] = {...newelement};
    // formBuilderStore.updateFormData(storeData);
  }
}
